<template>
  <section class="main-content clearfix">
    <Lefter></Lefter>
    <div class="right-container clearfix">
      <div class="right-title">
        依据《中华人民共和国电子商务法》、《网络交易监督管理办法》及相关法律规定，唯品会开放平台对因违法违规行为被采取处罚、屏蔽或者终止服务等处理措施的商家店铺，进行如下信息公示：
      </div>
      <List></List>
    </div>
  </section>
</template>

<script>
import Lefter from './lefter.vue'
import List from './list.vue'
export default {
  name: '',
  components: {
    Lefter,
    List
  }
}
</script>

<style lang="scss" scoped>

.main-content {
  padding: 10px 0;
  .right-container {
    margin-left: 248px;
    background: #fff;
    padding-left: 30px;
    min-height: 448px;
    .right-title {
      color: #333;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      padding: 18px 0;
      margin-right: 30px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
